import { useContext } from "react";
import formatDateString from "../../../Util/functions/FormatDateString";
import { AppContext } from "../../../Util/contexts/AppContext";

const Resubscribe = () => {
  const { userData } = useContext(AppContext);
  const slugButton = async () => {
    try {
      const url = "https://admin.ccdmcases.com" + "/getslug.webapi"; //TODO Set this url to your admin service!
      console.log("About to send request to ", url);

      const requestBody = {
        email: userData.CustomerEmail,
        password: userData.password || userData.Password,
        productName: "oet",
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Success:", data);

        if (data && data.container && data.container.Slug) {
          const extractedSlug = data.container.Slug;
          window.open(
            `https://www.occenglish.com/purchase/?slug=${extractedSlug}`,
            "_blank"
          );
          console.log("Extracted Slug:", extractedSlug);
        } else {
          console.error("Slug not found in the response");
          alert("Unable to generate subscription link. Please try again.");
        }
      } else {
        console.error("Error:", response.statusText);
        alert(`Request failed: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert(`An error occurred: ${error.message}`);
    }
  };

  const getSubscriptionDaysRemaining = () => {
    let expirationDate = new Date(userData.LicenseExpiration);
    let today = new Date();
    let daysRemaining = Math.floor(
      (expirationDate - today) / (1000 * 60 * 60 * 24)
    );
    return daysRemaining;
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Resubscribe</h3>
      <p className="accountSettingsToggleDescription">
        You have <strong>{getSubscriptionDaysRemaining()} Days</strong>{" "}
        remaining in your subscription ending{" "}
        <strong>
          {formatDateString(userData.LicenseExpiration, userData.TimeZone)}
        </strong>
        . If you need more time to study, you can resubscribe by following these
        instructions:
      </p>
      <ol className="accountSettingsOrderedList">
        <li className="accountSettingsOrderedListNumber">1</li>
        <li className="accountSettingsOrderedListItem">
          <p>
            Click “Resubscribe” or navigate to{" "}
            <a
              href="https://occenglish.com/purchase"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://occenglish.com/purchase
            </a>
          </p>
        </li>
        <li className="accountSettingsOrderedListNumber">2</li>
        <li className="accountSettingsOrderedListItem">
          <p>
            Select the amount of time that you would like to extend your
            subscription
          </p>
        </li>
        <li className="accountSettingsOrderedListNumber">3</li>
        <li className="accountSettingsOrderedListItem">
          <p>
            At checkout, use the same e-mail address that you used to subscribe
            originally. The system will automatically locate your account and
            extend your subscription.
          </p>
        </li>
      </ol>
      <button className="accountSettingsButton" onClick={slugButton}>
        Resubscribe
      </button>
    </div>
  );
};

export default Resubscribe;
